import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import type { Message } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import type { ChannelThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface AttentiveThreadViewProps {
  messages: Message[];
  supportTicketId: SupportTicketId;
  thread: ChannelThread;
}

export const AttentiveThreadView = memo(function AttentiveThreadView({
  messages,
  supportTicketId,
  thread,
}: AttentiveThreadViewProps) {
  return (
    <ChatThreadView
      channel={thread.channel}
      messages={messages}
      supportTicketId={supportTicketId}
      thread={thread}
    />
  );
});
